import axios from "axios";
import apiURI from "./Api";
import { typeTransfer } from "../pages/UserDashboard/components/WithdrawIntent/WithdrawIntent";

export default class WalletService {
  async postWithdrawIntent(
    token,
    username,
    amount,
    email = null,
    type = typeTransfer.PAYPAL,
    bankName = null,
    bankAccountNumber = null,
    accountOwner = null
  ) {
    let bodyJson = {};
    if (type === typeTransfer.PAYPAL) {
      bodyJson = {
        amount: amount,
        user: { username: username },
        paypalEmailToTransfer: email,
        typeWithdraw: typeTransfer.PAYPAL,
      };
    } else {
      bodyJson = {
        amount: amount,
        user: { username: username },
        typeWithdraw: typeTransfer.BANK,
        bankname: bankName,
        iban: bankAccountNumber,
        accountOwner: accountOwner,
      };
    }

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/intent`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postWithdrawRequest(
    token,
    username,
    amount,
    email,
    passwordfinantial,
    type = typeTransfer.PAYPAL,
    bankName = null,
    bankAccountNumber = null,
    accountOwner = null
  ) {
    let bodyJson = {};
    if (type === typeTransfer.PAYPAL) {
      bodyJson = {
        amount: amount,
        user: { username: username },
        paypalEmailToTransfer: email,
        passwordfinantial: passwordfinantial,
      };
    } else {
      bodyJson = {
        amount: amount,
        user: { username: username },
        passwordfinantial: passwordfinantial,
        typeWithdraw: typeTransfer.BANK,
        bankname: bankName,
        iban: bankAccountNumber,
        accountOwner: accountOwner,
      };
    }

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/request`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
